import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceColor } from '../tokens';

export const styledMuiLinearProgress = (
  theme: Theme,
): BackstageOverrides['MuiLinearProgress'] => ({
  root: {
    backgroundColor: getSurfaceColor(theme, 'subtle'),
    borderRadius: 999,
    height: 8,
  },
  bar: {
    borderRadius: 999,
  },
});
